import { forwardRef } from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Link from '@mui/material/Link';
import { RouterLink } from '../routerLink';

interface Props extends BoxProps {
  disabledLink: boolean;
}

const Logo = forwardRef(
  ({ disabledLink = false, sx, ...other }: Props, ref) => {
    const logo = (
      <Box
        ref={ref}
        component="div"
        sx={{
          width: 40,
          height: 40,
          display: 'inline-flex',
          ...sx,
        }}
        {...other}
      >
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 57 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_11_35)">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M35.9511 42C29.732 42 24.144 39.299 20.2973 35.0066H30.9204V34.03H24.1519V19.6764H27.8055V31.1406H29.0234V19.6764H32.7004V31.1406H33.5201V35.0066H51.6048C47.7583 39.299 42.1701 42 35.9511 42ZM15.1046 18.3725H56.7976C55.5042 8.01465 46.6641 0 35.9511 0C25.2382 0 16.398 8.01465 15.1046 18.3725ZM56.9684 21C56.9684 21.2048 56.9652 21.409 56.9593 21.6124H35.9786V20.8617H56.9676C56.968 20.8841 56.968 20.9066 56.968 20.929C56.968 20.9526 56.9684 20.9763 56.9684 21ZM35.9786 22.4026H56.9221C56.9055 22.6541 56.8846 22.9044 56.8593 23.1533H35.9786V22.4026ZM35.9786 23.9436H56.7636C56.728 24.1952 56.6885 24.4455 56.6442 24.6943H35.9786V23.9436ZM35.9786 25.4845H56.4881C56.4332 25.7364 56.3739 25.9867 56.3102 26.2352H35.9786V25.4845ZM35.9786 27.0254H56.0905C56.015 27.2777 55.9351 27.5279 55.8505 27.7761H35.9786V27.0254ZM35.9786 28.5663H55.5631C55.4655 28.819 55.3631 29.0692 55.256 29.317H35.9786V28.5663ZM35.9786 30.1072H54.8951C54.773 30.3604 54.6461 30.6106 54.5141 30.858H35.9786V30.1072ZM35.9786 31.6482H54.0709C53.9215 31.9019 53.7666 32.1522 53.6069 32.3989H35.9786V31.6482ZM35.9786 33.1891H53.0689C52.8871 33.4436 52.6997 33.6939 52.5072 33.9398H35.9786V33.1891ZM56.9482 20.0715C56.9371 19.8201 56.9217 19.5698 56.902 19.3208H35.9786V20.0715H56.9482ZM0 34.0583H3.7253V22.5844H6.44313V19.7159H0V34.0583ZM7.5104 19.7159H13.6811V22.5826H11.2362V25.2861H13.4948V28.0129H11.2362V31.1826H13.914V33.9793H7.5104V19.7159ZM18.7217 34.036H15.0739V19.7085H19.5869C21.0834 19.7085 22.5691 20.3752 22.8839 21.555C23.1645 22.6067 23.1439 25.1544 23.0008 26.1828C22.939 26.6269 22.5565 28.0526 20.3117 28.2162C19.7652 28.256 19.4571 28.2468 19.208 28.2393H19.208C19.053 28.2346 18.9209 28.2306 18.7684 28.2396V34.036H18.7217ZM19.2361 22.1159H18.7684V25.7854C18.7684 25.7854 19.0958 25.7854 19.3296 25.7621C19.5635 25.7387 19.9844 25.505 19.9844 25.0843C19.9844 24.8636 19.9791 24.497 19.9736 24.11C19.9675 23.6773 19.9609 23.219 19.9609 22.9106C19.9532 22.6924 19.8674 22.1159 19.2361 22.1159Z"
              fill="#0173AA"
            />
          </g>
          <defs>
            <clipPath id="clip0_11_35">
              <rect width="57" height="42" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </Box>
    );

    if (disabledLink) {
      return logo;
    }

    return (
      <Link component={RouterLink} href="/" sx={{ display: 'contents' }}>
        {logo}
      </Link>
    );
  },
);

export default Logo;
